import { EChannel, ETxnType } from './entryRecords';

export interface IRefundOrderParams {
  page: number;
  size: number;
  /** 主键 */
  id?: number;
  /** 退款订单号 */
  refundNo?: string;
  /** 退款订单号（支付平台） */
  tpRefundNo?: string;
  /** 支付通道 YEEPAY：易宝支付 */
  channel?: EChannel;
  /** 交易方式 WECHAT_PAY：微信支付 ALIPAY： 支付宝 */
  txnType?: ETxnType;
  /** 结算时间开始 */
  refundTimeStart?: string;
  /** 结算时间结束 */
  refundTimeEnd?: string;
  /** 退款成功时间 */
  refundSuccessTime?: string;
  /** 退款状态 PROCESSING：退款处理中 SUCCESS：退款成功 FAILED：退款失败  */
  refundStatus?: ERefundStatus;
  /** 企业id */
  companyId?: number;
  /** 代理商id */
  agentId?: number;
  /** 是否是门店订单。默认：false */
  fromStore?: boolean;
  /** 最小退款金额 */
  refundAmtMin?: number;
  /** 最大退款金额 */
  refundAmtMax?: number;
}

export interface IRefundOrderInfo {
  /**  */
  id: number;
  /** 收款订单号 */
  orderNo: string;
  /** 收款订单号（支付平台） */
  tpOrderNo: string;
  /** 退款订单号 */
  refundNo: string;
  /** 退款订单号（支付平台） */
  tpRefundNo: string;
  /** 收单金额 */
  rcptAmt: number;
  /** 退款金额 */
  refundAmt: number;
  /** 返还手续费 */
  returnFee: number;
  /** 实际退款金额 */
  actualRefundAmt: number;
  /** 支付通道 YEEPAY：易宝支付 */
  channel: EChannel;
  /** 交易方式 WECHAT_PAY：微信支付 ALIPAY： 支付宝   */
  txnType: ETxnType;
  /** 退款时间 */
  refundTime: string;
  /** 退款成功时间 */
  refundSuccessTime: string;
  /** 退款状态 PROCESSING：退款处理中 SUCCESS：退款成功 FAILED：退款失败  */
  refundStatus: string;
  /** 退款失败原因 */
  refundFailedReason: ERefundStatus;
  /** 备注 */
  remark: string;
}

export interface IReceiptOrderRefundParams {
  /** 主键 */
  rcptOrderId: number;
  /** 退款金额 */
  refundAmt: number;
  /** 支付密码 */
  payPassword: string;
  /** 验证码 */
  verifyCode: string;
  /** 备注 */
  remark: string;
}

export interface IReceiptOrderRcptAmt {
  /** 收款金额 */
  rcptAmt: number;
  /** 收款手续费 */
  rcptFee: number;
  /** 实际到账金额 */
  actualAmt: number;
  /** 退款金额 */
  refundAmt: number;
  /** 剩余可退金额  */
  remainRefundAmt: number;
}

export enum ERefundStatus {
  /** 退款处理中 */
  PROCESSING = 'PROCESSING',
  /** 退款成功 */
  SUCCESS = 'SUCCESS',
  /** 退款失败 */
  FAILED = 'FAILED',
}

export const refundStatusConfig = { 
  [ERefundStatus.PROCESSING]: '退款中',
  [ERefundStatus.SUCCESS]: '退款成功',
  [ERefundStatus.FAILED]: '退款失败',
};

export const refundStatusStyle = { 
  [ERefundStatus.PROCESSING]: 'primary',
  [ERefundStatus.SUCCESS]: 'success',
  [ERefundStatus.FAILED]: 'danger',
};